import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import { CenterFrameLayout } from 'Layouts';
import { useSelectPlans } from 'Hooks/useSelectPlan';
import { useSubscription } from 'Hooks/useSubscription';
import { getFeatureFlag } from 'Utils/FeatureFlags';

export function withPlans(WrappedComponent) {
  return function WithPlans(props) {
    useSubscription();
    const { preSelectedPlan = '' } = useParams();
    useSelectPlans({ preSelectedPlan });

    const { requirePlanSelection } = useSelector((s) => s.purchaseMode);
    const { hasShippingAddress } = useSelector((s) => s.checkout);
    const isBango = useSelector((s) => s.integrations.bango.subscriptionId);
    const routes = useSelector((s) => s.appConfig.routes);
    const location = useLocation();
    const { isPlanSelected, selectedPlan, selectPlanActionComplete } = useSelector((s) => s.plans);
    const isSheerIdVerification =
      getFeatureFlag('featureFlag_sheerID') && location?.state?.from?.pathname.includes(routes.sheerIdVerification);

    if (requirePlanSelection) {
      // if :preSelectedPlan param exists and plan is being fetched,
      // show a CenterFrame with a <Loader />
      if (!selectPlanActionComplete) {
        if (!isPlanSelected) {
          return <CenterFrameLayout title="" modernLayout showLoader />;
        }

        if (selectedPlan && selectedPlan.hasMerchandise && !hasShippingAddress) {
          return <Navigate replace to={routes.shipping} />;
        }
      }

      if (selectPlanActionComplete && !isPlanSelected && !preSelectedPlan && !isBango && !isSheerIdVerification) {
        return <Navigate replace to={routes.signupPlans} />;
      }
    }
    return <WrappedComponent {...props} />;
  };
}
